// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--48393";
export var headingContainer = "index-module--heading-container--46b2e";
export var highlight = "index-module--highlight--347cf";
export var highlightLine = "index-module--highlight-line--029f7";
export var image1 = "index-module--image-1--94040";
export var image2 = "index-module--image-2--2c681";
export var imageContainer = "index-module--image-container--bc743";